import React from "react";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  TelegramShareButton,
} from "react-share";
import Image from "next/image";
import facebookW from "@/public/images/FacebookW.svg";
import telegram from "@/public/images/telegramW.svg";
import linkedin from "@/public/images/linkedinW.svg";
import twitter from "@/public/images/twitterW.svg";
import share from "@/public/images/share.svg";

interface Props {
  title: string;
}

const ShareComponent: React.FC<Props> = ({ title }) => {
  const shareUrl = window.location.href;

  const handleShareClick = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: title,
          url: shareUrl,
        });
        console.log("Share was successful.");
      } catch (error) {
        console.error("Sharing failed", error);
      }
    } else {
      console.log("Web Share API is not supported in your browser.");
    }
  };

  return (
    <div className="flex flex-col gap-3 w-full mt-4">
      <p className="text-white text-bold text-xl">فيد غيرك بالشير</p>
      <div className="flex items-center gap-2 flex-wrap">
        <FacebookShareButton
          url={shareUrl}
          title={title}
        >
          <Image
            src={facebookW}
            alt="facebookW"
          />
        </FacebookShareButton>
        <TelegramShareButton
          url={shareUrl}
          title={title}
        >
          <Image
            src={telegram}
            alt="telegram"
          />
        </TelegramShareButton>
        <LinkedinShareButton
          url={shareUrl}
          title={title}
        >
          <Image
            src={linkedin}
            alt="linkedin"
          />
        </LinkedinShareButton>
        <TwitterShareButton
          url={shareUrl}
          title={title}
        >
          <Image
            src={twitter}
            alt="twitter"
          />
        </TwitterShareButton>
        <button onClick={handleShareClick}>
          <Image
            src={share}
            alt="share"
          />
        </button>
      </div>
    </div>
  );
};

export default ShareComponent;
